import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    appVersion: "0.6.0",
    app_domain: process.env.VUE_APP_LOCAL_DOMAIN, // TODO fix envs
    api_url: process.env.VUE_APP_LOCAL_API, // TODO fix envs
    env: {
      app_domain: null,
      api_url: null,
      site_url: null,
    },
    layout: {
      card_class: "row-cols-1 row-cols-md-2",
      logo: "/logos/imc-exponential.png",
    },
    loading: {
      number_to_load: 0,
      page: 0,
    },
    menu: {
      items: {},
    },
    notifications: {},
    unReadNotificationsCount: 0,
    preFlightData: {},
    profile: {
      status: 0,
    },
    profile_active: {},
    session_id: null,
    show_loading: 1,
    year: null,



    categories: [],
    category_exists: 0,
    category_slug: null,
    search_term: null,
  },
  mutations: {
    appDomainSet(state, data) {
      console.log("STORE:appDomainSet:" + data);
      this.state.app_domain = data;
    },
    appUrlSet(state, data) {
      console.log("STORE:appUrlSet:" + data);
      this.state.api_url = data;
    },
    envSet(state, data) {
      this.state.env.app_domain = data.app_domain;
      this.state.env.api_url = data.api_url;
      this.state.env.site_url = data.site_url;
    },
    layoutCardClassSet(state, data) {
      console.log("layoutCardClassSet");
      state.layout.card_class = data;
    },
    loadingSet(state, data) {
      console.log("loadingSet");
      state.loading.page = data;
    },
    loadingNumberTotalSet(state, data) {
      console.log("loadingSet");
      state.loading.number_to_load = data;
    },
    menuSet(state, data) {
      state.menu = data.menu;
    },
    notificationsSet(state, data) {
      state.notifications = data;
    },
    profileActiveSet(state, data) {
      console.log("STORE:profileActiveSet");
      state.profile_active = data;
    },
    profileSet(state, data) {
      console.log("STORE:profileSet");
      if (!data || !data.profile) return;
      state.profile = data.profile;
      state.session_id = data.profile.session_id;
      data.profile.is_admin = (data.profile.level >= 90) ? 1 : 0;
    },
    profileTimezoneSet(state, data) {
      console.log("STORE:profileTimezoneSet");
      console.log(state);
      console.log(data);
      state.profile.timezoneOffsetH = data.timezoneOffsetH;
    },


    categoryActiveSet(state, data){
      console.log('categoryActiveSet:' + data);
      var result = 0;

      if(data === 'latest'){
        state.category_slug = null;
        state.category_exists = 1;
        return true;
      }
      else
      {
        if(typeof this.getters.categoriesGet !== 'undefined'){
          result = this.getters.categoriesGet.filter(function(e) {
            if(e.slug == data){
              return 1;
            }
          });
        }
      }

      state.category_exists = result.length;
    },

    categoriesSet(state, data){
      state.categories = Object.values(data);
    },
    categorySlugSet(state, slug){
      state.category_slug = slug;
    },
    searchTermSet(state, data){
      state.search_term = data.search_term;
    },

  },
  computed: {},
  actions: {},
  modules: {},
  getters: {
    appVersion: (state) => {
      return state.appVersion;
    },
    isLoggedIn: (state) => {
      var status = 0;
      if (typeof state.profile.status !== "undefined") {
        status = state.profile.status;
      }
      return status;
    },
    loadingStatus: (state) => {
      return state.loading.page;
    },
    menuGet: (state) => {
      return state.menu;
    },
    menuGetItems: (state) => {
      if (state.menu.items) {
        return state.menu.items;
      } else {
        return null;
      }
    },
    notificationsTotal: (state) => {
      var total = 0;
      for (const val of Object.values(state.notifications)) {
        total += val;
      }
      return total;
    },
    profileGet: (state) => {
      return state.profile;
    },
    profileGetUserlevel: (state) => {
      return parseInt(state.profile.level);
    },
    profileGetName: (state) => {
      if (state.profile.first_name !== null) {
        return state.profile.user_name;
      } else {
        return state.profile.first_name;
      }
    },
    profileId: (state) => {
      return state.profile.id;
    },
    profileUserName: (state) => {
      return state.profile.user_name;
    },
    serverDate: (state) => {
      return state.profile.server_date;
    },
    sessionIdGet: (state) => {
      return state.session_id;
    },


    categoriesGet: state => {
      return state.categories;
    },
    categoryActiveGet: state => {
      var result = null;
      var category = null;
      if(state.categories !== 'undefined' && state.categories.length > 0){
        result = state.categories.filter(function(e) {
          if(e.slug == state.category_slug){
            return 1;
          }
        });
      }

      if(state.category_slug === null){
        category = null;
      }
      else if(result !== null && result[0]){
        category = result[0];
      }

      return category;
    },

    searchTermGet: state => {
      return state.search_term;
    },

  },
});

export default store;
